export const PhoneNumberMatch = "^([\\(]{1}\\d{3}[\\)]{1}\\d{3}[\\-]{1}\\d{4})$";
export const NameMatch = "^([a-zA-Z.'-,]).{1,50}$";
export const PasswordMatch = "^(?=[^\\d].\\d)(?=.[a-z])(?=.[A-Z])(?!@#$%.\\s).{8,50}$";
export const UserNameMatch = "^(?=.{8,20}$)(?![.])(?!.*[.]{2})[a-zA-Z0-9.]+(?<![.])$";
export const EmailMatch = "^([a-zA-Z0-9\\-\\.\\_\\+]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([a-zA-Z0-9\\-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)$";
export const NonDigitMatch = "[^0 - 9]";